import React, { Component } from 'react';
import './App.css';

class Login extends Component{
  constructor(){
    super();
    this.handleSubmit = this.login.bind(this);
  }
  password = (e) =>{
    this.setState({
      passValue : new Buffer(e.target.value).toString('base64')
    })
  }
  login(event){
    event.preventDefault();
    var passV = this.state.passValue;
    console.log(this.state.passValue);
    if (passV) {
      if(passV == 'OTk0MDc3MDA2MA=='){
        var validUntil = (new Date().getTime() + 2000);
        console.log(validUntil);
        sessionStorage.setItem('gozu',passV);
        window.location.href = '/doc'
      }
      else {
        alert("wrong password! Please Try again")
      }
    }
    // var data = new FormData(event.target);
    // var setData = JSON.stringify(data);
    // localStorage.setItem('pass',setData);
    // console.log(event.target.value);
  }
  render(){
    return(
      <section className="loginbox container">
        <form onSubmit={this.handleSubmit}>
          <h4 className="nopad nomargin">Please Enter the Password to access the document</h4>
        <input className="input" id="password"  onChange={this.password} type="password" name="pass" placeholder="password" autoFocus />
        <button className="btn">Go</button>
      </form>
      </section>
    )
  }
}
export default Login;



// WEBPACK FOOTER //
// ./src/login.jsx